const amlClaims = ["AmlAdmin", "AmlReader"];
export default amlClaims;

export const amlAdminWithDev = ["AmlAdmin", "Dev"];
export const amlWithDev = ["Dev", "AmlAdmin", "AmlReader"];
export const fundManager = ["FundManager"];
export const allClaimsOtherThanAml = [
  "Dev",
  "StaffManager",
  "FundManager",
  "CompanyManager",
  "TermsManager",
  "SalesRepManager",
];
export const allClaims = [...allClaimsOtherThanAml, ...amlClaims];
